module.exports = [{
      plugin: require('/Users/nick/Projects/github/Sharekey Website/node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/nick/Projects/github/Sharekey Website/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
